export default __webpack_public_path__ + "static/aimyvoice_logo-b5281b3ff5a02c2cf832e0cd66587b1f.svg";